import classNames from 'classnames';
import { AlternativeButton, Button } from 'components/1-atoms/Buttons';
import styles from './TravelDeductionNav.module.scss';

export type TravelDeductionNavAction = 'next' | 'back' | 'restart';

export interface TravelDeductionNavProps {
	actions: {
		next?: string;
		back?: string;
		restart?: string;
	};
	currentStep: number;
	totalSteps: number;
	navActionCallBack: (action: TravelDeductionNavAction) => void;
}

export const TravelDeductionNav = ({ actions, currentStep, totalSteps, navActionCallBack }: TravelDeductionNavProps) => {
	return (
		<div className={styles.TravelDeductionNav}>
			{currentStep != 1 && (
				<AlternativeButton
					className={classNames(styles.TravelDeductionNav_button, styles.TravelDeductionNav_button___back)}
					onClick={() => navActionCallBack('back')}
					label={actions?.back}
					icon="ArrowLeft"
					type="button"
				/>
			)}
			{currentStep != totalSteps && (
				<Button className={classNames(styles.TravelDeductionNav_button, styles.TravelDeductionNav_button___next)} type="submit">
					{actions?.next}
				</Button>
			)}
			{currentStep === totalSteps && (
				<Button
					className={classNames(styles.TravelDeductionNav_button, styles.TravelDeductionNav_button___next)}
					onClick={() => navActionCallBack('restart')}
				>
					{actions?.restart}
				</Button>
			)}
		</div>
	);
};
